/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import HomePageVM from 'clients/strapi/models/HomePageVM'
import { NavigationItems } from 'constants/navigationItems'
import { useDeviceType } from 'hooks/useDeviceType'
import { motion, Variants } from 'motion/react'
import Link from 'next/link'
import { useState } from 'react'
import PangeaWidget from '../PangeaWidget/PangeaWidget'
import styles from './HomePage.module.scss'
// import Marquee, { MarqueeImage } from 'components/Marquee/Marquee'

type Props = {
  viewModel: HomePageVM
}

// const desktopLetters: MarqueeImage[] = [
//   {src: '/assets/home/Desktop_P.svg', width: 245, height: 350, alt: 'P'},
//   {src: '/assets/home/Desktop_I.svg', width: 210, height: 350, alt: 'I'},
//   {src: '/assets/home/Desktop_X.svg', width: 210, height: 350, alt: 'X'},
//   {src: '/assets/home/Desktop_I-1.svg', width: 210, height: 350, alt: 'I-1'},
//   {src: '/assets/home/Desktop_O.svg', width: 350, height: 350, alt: 'O'},
//   {src: '/assets/home/Desktop_N.svg', width: 210, height: 350, alt: 'N'},
//   {src: '/assets/home/Desktop_P.svg', width: 245, height: 350, alt: 'P1'},
//   {src: '/assets/home/Desktop_I.svg', width: 210, height: 350, alt: 'I1'},
//   {src: '/assets/home/Desktop_X.svg', width: 210, height: 350, alt: 'X1'},
//   {src: '/assets/home/Desktop_I-1.svg', width: 210, height: 350, alt: 'I-11'},
//   {src: '/assets/home/Desktop_O.svg', width: 350, height: 350, alt: 'O1'},
//   {src: '/assets/home/Desktop_N.svg', width: 210, height: 350, alt: 'N1'},
// ]

const HomePage = ({ viewModel }: Props) => {
  const { isMobile, isTablet } = useDeviceType()

  const [hoveredItem, setHoveredItem] = useState(NavigationItems.Pixion)

  const variants: Variants = {
    hidden: {
      scaleY: 0,
      transformOrigin: 'top',
      transition: {
        duration: 0.4,
        ease: 'circIn',
      },
    },
    visible: {
      scaleY: 1,
      transition: {
        duration: 0.4,
        ease: 'circIn',
      },
    },
  }

  const textVariants: Variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: { delay: 0.6, duration: 0.2 },
    },
  }

  const textAnimation = {
    variants: textVariants,
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
  }

  const imageVariants: Variants = {
    hidden: {
      opacity: 0,
      y: 80,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.6, duration: 0.2 },
    },
  }

  const imageAnimation = {
    variants: imageVariants,
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
  }

  function getOpacityOnHover(itemKey: string) {
    return hoveredItem.key === 'pixion' ? 1 : hoveredItem.key === itemKey ? 1 : 0.3
  }

  /*
    <Marquee images={desktopLetters} imagesMobile={desktopLetters} imagesTablet={desktopLetters} homepage={true} />
    <div className={styles.center}>
      <div className={styles.gregor} />
      <span className={styles.tagline}>{viewModel.tagline}</span>
    </div>
  */

  return (
    <motion.div className={styles.container} variants={variants} layoutRoot initial={{ scaleY: 1 }} animate='visible' exit='hidden'>
      <motion.div className={styles.content} {...textAnimation}>
        <div className={styles.pixion} />
        <ul className={styles.links} onMouseLeave={() => setHoveredItem(NavigationItems.Pixion)}>
          {Object.values(NavigationItems)
            .filter((x) => x.displayName !== '')
            .map((item) => (
              <li key={item.key} className={styles.link}>
                <Link href={item.href} style={{ opacity: getOpacityOnHover(item.key) }} onMouseOver={() => setHoveredItem(item)}>
                  {item.displayName}
                </Link>
              </li>
            ))}
        </ul>
        <div className={styles.required}>
          <Link href="/eu-project" className={styles['eu-project']} prefetch={false}>
            <span className={styles.title}>
              Explore EU Project
            </span>
            <img className={styles.logo} src='/assets/home/eu_co_funded.png' alt='Pixion EU project'/>
          </Link>
          <PangeaWidget />
        </div>
      </motion.div>

      {isMobile && <motion.img src={hoveredItem.srcMobile} style={{ zIndex: -1 }} draggable='false' {...imageAnimation} />}
      {isTablet && <motion.img src={hoveredItem.srcTablet} style={{ zIndex: -1 }} draggable='false' {...imageAnimation} />}
      {!isTablet && !isMobile && <motion.img src={hoveredItem.src} style={{ zIndex: -1 }} draggable='false' {...imageAnimation} />}
    </motion.div>
  )
}

export default HomePage
